import { IA_KEY } from 'helpers/ia-logic';
import { PAGE_LAYOUT_VARIANT } from 'features/App';

import { Settings, watchSettingsActions, handleProfileAccountSettingsEnter } from './Settings';
import { StaffAccounts, handleStaffAccountsRouteEnter, watchStaffAccountsActions } from './StaffAccounts';
import { Notifications, handleNotificationsRouteEnter, watchNotificationsActions } from './Notifications';

export default [
  {
    path: '/account/profile',
    component: Settings,
    pathSagas: [watchSettingsActions],
    locationSagas: [handleProfileAccountSettingsEnter],
    pageLayout: PAGE_LAYOUT_VARIANT.NARROW,
    hideVenueSelector: true,
  },
  {
    path: '/account/staff',
    component: StaffAccounts,
    iaKey: IA_KEY.ACCOUNT_STAFF,
    pathSagas: [watchStaffAccountsActions, handleStaffAccountsRouteEnter],
    pageLayout: PAGE_LAYOUT_VARIANT.NARROW,
    hideVenueSelector: true,
  },
  {
    path: '/account/notifications',
    component: Notifications,
    pathSagas: [watchNotificationsActions, handleNotificationsRouteEnter],
    pageLayout: PAGE_LAYOUT_VARIANT.NARROW,
    hideVenueSelector: true,
  },
];
